var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.32;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#083d77;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_166);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_13);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_122);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_7);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_7-2);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_36);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_78);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_78-2);}.cls-13{clip-path:url(#clip-path-2);}.cls-14{fill:#e6656c;}.cls-15,.cls-23{fill:#fff;}.cls-16,.cls-17,.cls-19{opacity:0.24;}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_78-3);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_78-4);}.cls-18{clip-path:url(#clip-path-4);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_78-5);}.cls-20{fill:#1a1a1a;}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_62);}.cls-22{opacity:0.57;}.cls-23{opacity:0.46;}.cls-24{fill:#ff715b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 100
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_166",
    x1: 108.63897,
    y1: 92.6163,
    x2: 90.22615,
    y2: 197.04062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15245,
    stopColor: "#efb4a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37918,
    stopColor: "#f5c0b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74489,
    stopColor: "#fccec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    x1: 58.1394,
    y1: 83.12619,
    x2: 81.3987,
    y2: 96.55495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb38b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19401,
    stopColor: "#ffb792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48456,
    stopColor: "#ffc1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83412,
    stopColor: "#ffd2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86108,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_122",
    x1: 95.49585,
    y1: 27.78067,
    x2: 114.28766,
    y2: 134.35434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8c7a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33484,
    stopColor: "#f8caaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83529,
    stopColor: "#f8d1c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    stopColor: "#f8d1c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_7",
    x1: 107.79485,
    y1: 71.60664,
    x2: 85.70333,
    y2: 71.60664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8840b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34864,
    stopColor: "#de8b10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86956,
    stopColor: "#f0a01f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_7-2",
    x1: 120.04607,
    y1: 66.91603,
    x2: 139.58316,
    y2: 66.91603,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36",
    x1: 54.43886,
    y1: 53.86644,
    x2: 143.04677,
    y2: 53.86644,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78",
    x1: 109.1579,
    y1: 99.28853,
    x2: 125.08391,
    y2: 99.28853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67666,
    stopColor: "#f89a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29d7c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78-2",
    x1: 101.36823,
    y1: 109.45439,
    x2: 127.9584,
    y2: 109.45439,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_78"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.43809,108.38263c-.58645,1.25223,2.61537,4.485,6.00576,6.00576,5.80257,2.60264,11.64265-.04069,12.01151-.21449,6.28759-2.96319,9.19192-9.95589,8.36516-10.72457-.30634-.28482-1.06161.34389-3.00287,1.28695a31.25786,31.25786,0,0,1-10.72457,3.00288c-2.39465.15233-3.83487-.18679-10.29559,0C102.70692,107.77068,101.70573,107.81116,101.43809,108.38263Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78-3",
    x1: 82.61322,
    y1: 94.04193,
    x2: 102.1089,
    y2: 94.04193,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78-4",
    x1: 112.89723,
    y1: 122.51872,
    x2: 122.24375,
    y2: 122.51872,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_78"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.7567,59.4786c1.0545,5.43743.2002,4.06817,1.50144,23.594.74517,11.18125,1.20725,14.36092-.64347,19.08973-1.19578,3.05525-2.32186,4.11231-4.28983,9.43762-1.30444,3.52973-1.57119,5.12585-3.43186,10.29559-1.5448,4.292-2.3172,6.43809-3.00288,7.2927-3.66588,4.56915-10.59852,5.47089-15.44337,4.71881-1.42389-.221-3.36641-.69343-8.36517-3.43186-8.49649-4.65461-12.94012-7.0889-16.73032-11.797-2.34239-2.90967-4.16734-8.3426-7.72169-19.08973-2.05966-6.22774-3.08949-9.34164-4.71881-15.22889-5.86908-21.207-8.80362-31.81049-7.07821-36.89251C69.959,35.313,85.16942,28.814,96.50479,27.73389c11.05877-1.05382,25.26133,2.39894,32.81717,12.655C133.03089,45.42324,134.03459,50.59879,135.7567,59.4786Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78-5",
    x1: -1350.51557,
    y1: 136.37826,
    x2: -1331.01989,
    y2: 136.37826,
    gradientTransform: "matrix(-0.99789, 0.06498, 0.06498, 0.99789, -1210.03531, 40.78806)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_62",
    x1: 58.9965,
    y1: 37.92953,
    x2: 74.15195,
    y2: 37.92953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8840b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30074,
    stopColor: "#d78612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75001,
    stopColor: "#d48a27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9981,
    stopColor: "#d28d35"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MinDef_ILLU_vectorisation_v3 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Max"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.36563,91.22332C97.84279,90.94165,84.85612,89.49158,79.56,96.8001c-1.05978,1.46248-2.45906,4.16907-.429,27.66938.87776,10.16127,1.65649,15.64127-1.71593,18.44626-2.63841,2.19445-6.3784,1.55375-8.57966,1.28694-14.87981-1.80359-34.61,4.37556-37.107,10.93906-3.06645,8.06029,16.257,26.16109,38.39395,35.60557,33.55219,14.31468,77.35649,10.36031,87.298-8.36517.58985-1.111,5.60395-10.85925,1.50144-18.01727-2.443-4.26249-7.19164-5.98889-11.368-7.5072-10.65314-3.87294-14.397-.05828-19.73321-3.64635-6.7161-4.51589-7.983-15.39776-7.07821-22.3071,1.326-10.12539,7.36345-11.24435,6.86372-18.23176C126.85835,102.218,113.24585,92.6615,100.36563,91.22332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.07739,85.81274c-2.4326-4.33312-7.82023-10.53721-12.23266-9.48581-2.5013.596-3.7082,3.28986-4.177,4.33637-2.94679,6.57761,1.607,15.3097,8.354,19.7847,1.7267,1.1453,6.19412,4.10829,8.95072,2.71023C80.7302,101.2524,79.60946,92.10417,76.07739,85.81274Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.7567,59.4786c1.0545,5.43743.2002,4.06817,1.50144,23.594.74517,11.18125,1.20725,14.36092-.64347,19.08973-1.19578,3.05525-2.32186,4.11231-4.28983,9.43762-1.30444,3.52973-1.57119,5.12585-3.43186,10.29559-1.5448,4.292-2.3172,6.43809-3.00288,7.2927-3.66588,4.56915-10.59852,5.47089-15.44337,4.71881-1.42389-.221-3.36641-.69343-8.36517-3.43186-8.49649-4.65461-12.94012-7.0889-16.73032-11.797-2.34239-2.90967-4.16734-8.3426-7.72169-19.08973-2.05966-6.22774-3.08949-9.34164-4.71881-15.22889-5.86908-21.207-8.80362-31.81049-7.07821-36.89251C69.959,35.313,85.16942,28.814,96.50479,27.73389c11.05877-1.05382,25.26133,2.39894,32.81717,12.655C133.03089,45.42324,134.03459,50.59879,135.7567,59.4786Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M107.01486,69.77419c.48643.92944,1.04272,1.99227.64348,2.57389-.53267.77607-2.33165.06243-4.50432-.21449a19.85666,19.85666,0,0,0-10.08109,1.71593c-3.89206,1.5923-5.80363,3.78968-6.86373,3.00288-.69578-.51643-.49213-1.92314-.429-2.3594a6.00432,6.00432,0,0,1,2.35941-3.64635,20.33688,20.33688,0,0,1,10.08109-4.28983c4.38681-.79906,5.76576-.06169,6.22025.21449A7.53982,7.53982,0,0,1,107.01486,69.77419Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.9568,70.41766c.813.54775,1.69588-.28434,4.502-1.10874,2.11637-.62175,5.01624-1.47322,8.00048-.84964,3.03859.63494,4.49861,2.47194,5.51477,1.74389.68019-.48732.73957-1.81611.429-2.78839-1.32413-4.14487-10.1963-4.40361-14.15643-4.07533-1.92451.15956-3.19318.49952-4.07534,1.50144C119.68766,66.526,119.72861,69.59017,120.9568,70.41766Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.67561,50.899c-.07556.78905-.61488,5.60191-4.71881,8.36516-.55932.37662-4.1243,2.58589-7.2927,1.50144a8.22194,8.22194,0,0,1-5.1478-7.2927,5.096,5.096,0,0,1-1.28694,3.86084c-1.08131,1.06455-2.47472,1.07282-8.15068,1.50144-2.90893.21968-4.36429.50167-5.14779,1.07246-2.99575,2.18256-3.75548,8.50985-1.07245,10.29558,1.60894,1.07083,3.98573.19559,4.9333-.21449a7.34388,7.34388,0,0,1-7.07822,2.14491,7.59056,7.59056,0,0,1-4.71881-4.50431c-1.09026-2.83317.28027-4.70771-.64347-5.36229-1.43913-1.01983-7.06266,1.90215-8.57966,6.64923-1.32669,4.15164,1.7472,5.75734.858,10.72457a14.67585,14.67585,0,0,1-7.93618,10.08109,14.97891,14.97891,0,0,1-7.29271,1.50144,11.97238,11.97238,0,0,0,5.79127-3.00288,11.56469,11.56469,0,0,0,2.14491-2.78838,25.22109,25.22109,0,0,1-5.14779-1.50144c-3.43861-1.41572-6.0089-2.47393-6.86372-4.71881-1.03093-2.70738,1.47442-4.4064.429-7.93618-.51732-1.74672-1.40529-2.25724-2.3594-3.64635-4.03313-5.87186-.6496-14.923-.21449-16.08686a23.09647,23.09647,0,0,1,7.50719-10.08109c-.98249-1.52783-2.13638-3.78832-1.28695-5.36228.94715-1.755,3.4857-.99019,6.43474-2.35941,4.54156-2.10862,3.61913-6.28932,8.15068-10.51007,2.65265-2.47074,5.55776-3.29158,11.368-4.9333,4.31679-1.21971,8.36139-2.36255,13.513-1.50144a23.69434,23.69434,0,0,1,8.15067,3.00288,15.15207,15.15207,0,0,1,8.15067-.2145c7.67634,2.00164,10.62476,9.65321,10.93906,10.51008a32.52394,32.52394,0,0,1,3.64636,2.3594c1.13084.844,5.367,4.00585,7.72168,8.15068,3.78638,6.66494,2.56573,14.16606,1.50144,20.37667-.55534,3.24057-.90865,3.36128-1.71593,7.29271a74.36671,74.36671,0,0,0-1.50144,16.94482,36.90007,36.90007,0,0,1-3.86084-12.655c-.69914-6.34342.756-9.4515-1.07246-13.72745C132.03269,54.6405,128.32308,52.23072,125.67561,50.899Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M109.15978,98.08705c.10661-.42527,4.76725.21313,7.2927.64347,2.11444.36033,2.56662.5466,3.64636.429,2.95108-.32147,4.61842-2.26273,4.9333-1.93042.29984.31645-.71223,2.60437-2.78839,3.64635-2.02767,1.01769-4.18316.4017-8.36516-.858C112.06311,99.47061,109.07227,98.43622,109.15978,98.08705Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M101.43809,108.38263c-.58645,1.25223,2.61537,4.485,6.00576,6.00576,5.80257,2.60264,11.64265-.04069,12.01151-.21449,6.28759-2.96319,9.19192-9.95589,8.36516-10.72457-.30634-.28482-1.06161.34389-3.00287,1.28695a31.25786,31.25786,0,0,1-10.72457,3.00288c-2.39465.15233-3.83487-.18679-10.29559,0C102.70692,107.77068,101.70573,107.81116,101.43809,108.38263Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M100.58012,113.31593c.47428-3.0366,10.2538-3.76758,14.37092-4.07533,5.01081-.37453,11.05788-.82655,12.01152,1.50144,1.06308,2.5952-4.224,8.59552-10.51008,9.8666C108.65214,122.1859,100.111,116.3197,100.58012,113.31593Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M102.296,105.59424q.10722,1.93042.2145,3.86085a22.79627,22.79627,0,0,0,24.452-3.00288q.21452-2.46667.429-4.9333Q114.8438,103.55656,102.296,105.59424Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M101.65258,97.65806c1.14163-1.95482-.07431-4.86889-1.287-6.43474-2.87866-3.71715-8.32463-3.17605-12.226-2.78838-2.40162.23863-4.724.46935-5.36229,1.93042-.835,1.9111,1.70117,4.80584,3.43186,6.22025C91.08014,100.56626,99.66162,101.0672,101.65258,97.65806Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M122.04368,120.28078c-1.14831-1.97068-8.6015-.82653-9.115,1.42053-.3371,1.475,2.08114,4.4533,5.2086,4.02482C121.34931,125.28606,122.80946,121.595,122.04368,120.28078Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M127.72386,93.96438c-1.26625-1.87651-.24224-4.86343.86609-6.50477,2.631-3.89636,8.10065-3.71029,12.019-3.577,2.412.08207,4.74445.1614,5.47639,1.57789.9574,1.8528-1.38527,4.90623-3.0204,6.43011C138.46294,96.17941,129.93214,97.23693,127.72386,93.96438Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M98.38182,81.12339c-1.367-.83265-3.3638-.64374-4.10124.34177-1.19661,1.59912.78584,5.47916,2.73416,5.46831,1.47689-.00826,3.224-2.254,2.73416-4.10123A2.9925,2.9925,0,0,0,98.38182,81.12339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M126.44516,78.19945a2.68789,2.68789,0,0,0-3.28087.27341c-.95725,1.27925.62865,4.38316,2.18725,4.37448,1.18146-.00661,2.57906-1.8031,2.18724-3.28086A2.394,2.394,0,0,0,126.44516,78.19945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.26151,38.67294a4.39431,4.39431,0,0,1-1.5824-2.20592,3.33656,3.33656,0,0,1,.265-3.01869,3.31932,3.31932,0,0,1,3.45066-.90975c-.30817-.20408-3.7946-2.44691-6.54685-1.04743-3.30906,1.68263-3.88577,7.7806-.94866,11.04264,3.123,3.46862,9.32068,2.73309,11.797-.429,1.56527-1.99876,2.10276-5.55321.429-7.29271a3.72859,3.72859,0,0,0-3.00288-1.07246,4.32041,4.32041,0,0,0-3.00288,2.14492A5.421,5.421,0,0,0,66.26151,38.67294Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Taches_rousseurs",
    "data-name": "Taches rousseurs",
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.09112,93.95064c.1559.356.86217.37924,1.31094.17521.117-.05319.42335-.19252.459-.43906.052-.36015-.48537-.87221-1.02259-.79155C98.30774,92.97494,97.94112,93.60818,98.09112,93.95064Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M129.479,90.78679c.1559.356.86217.37924,1.31095.17522.117-.05319.42334-.19252.459-.43906.052-.36015-.48537-.87222-1.02258-.79155C129.6956,89.8111,129.329,90.44433,129.479,90.78679Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M90.50462,98.26327a.58787.58787,0,0,0,.25722.45171.68132.68132,0,0,0,.82779-.413.74623.74623,0,0,0-.50927-.95232C90.75861,97.33909,90.45374,97.84821,90.50462,98.26327Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M124.75056,88.928a.58785.58785,0,0,0,.25722.45171.68132.68132,0,0,0,.82779-.413.74623.74623,0,0,0-.50927-.95232C125.00455,88.00378,124.69968,88.5129,124.75056,88.928Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M108.11485,89.47448a.86053.86053,0,0,0,.62337.664.97056.97056,0,0,0,1.14654-.9278.89555.89555,0,1,0-1.76991.26384Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M105.24842,94.5555c.1559.356.86217.37925,1.31094.17522.117-.05319.42335-.19252.459-.43906.052-.36015-.48537-.87222-1.02259-.79155C105.465,93.57981,105.09843,94.21305,105.24842,94.5555Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M68.40642,140.55633c5.12543,13.67445,17.30342,23.28336,31.31574,24.66651,18.06943,1.78364,30.02889-11.01546,31.31573-12.4405a82.90519,82.90519,0,0,1,29.17083,5.57677c7.74483,3.02838,14.14344,5.63381,16.94481,11.797,2.19645,4.83234.79094,8.79241-.64347,17.3738,0,0-1.32444,7.92361-2.14491,29.5998-.83728,22.1212,4.41927,26.43836,2.57389,34.31862-7.50908,32.06582-116.27,53.34152-143.7092,15.44337-4.74127-6.54848-8.16565-18.87953-15.01439-43.54174-3.66233-13.18787-5.42251-22.26929-5.57678-33.03167-.17254-12.03434-.17862-22.35234,6.64923-30.88675,4.85586-6.06954,10.93786-8.44916,20.59117-12.226A102.41849,102.41849,0,0,1,68.40642,140.55633Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMax);
export default __webpack_public_path__ + "static/media/avatar_max.15c5d3ba99d8296bba40aad23035a91c.svg";
export { ForwardRef as ReactComponent };